<template>
  <page-article
    :attachments="currentVisitsDetailsGetter.visit_attachments"
  >
    <template>
      <div class="page_article_block col-12">
        <ul class="article_info_list">
          <li class="article_info_item">
            <span class="article_tag">參訪單位</span>{{ currentVisitsDetailsGetter.visit_name }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">活動日期</span>
            {{ currentVisitsDetailsGetter.visit_event_start_date || new Date() | moment("YYYY/MM/DD HH:mm") }} ~ {{ currentVisitsDetailsGetter.visit_event_end_date || new Date() | moment("YYYY/MM/DD HH:mm") }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">報名日期</span>
            {{ currentVisitsDetailsGetter.visit_start_date || new Date() | moment("YYYY/MM/DD HH:mm") }} ~ {{ currentVisitsDetailsGetter.visit_end_date || new Date() | moment("YYYY/MM/DD HH:mm") }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">活動地點</span>{{ currentVisitsDetailsGetter.visit_location }}
          </li>
          <li class="article_info_item" v-if="currentVisitsDetailsGetter.visit_show_status">
            <span class="article_tag">活動狀態</span>
			<span :style="check_full()">
			{{ currentVisitsDetailsGetter.visit_students_count }}/{{ currentVisitsDetailsGetter.visit_taker }}
			</span>(已報名/總名額)
          </li>
          <li class="article_info_item mb-5">
            <span class="article_tag">注意事項</span>{{ currentVisitsDetailsGetter.visit_note }}
          </li>
          <li class="article_info_item">
            <span class="article_tag">詳細內容</span>
          </li>
        </ul>
        <div
          class="article_content"
          v-html="currentVisitsDetailsGetter.visit_content"
        />
        <div
          v-if="!isEnterpriseGetter"
          class="row justify-content-center"
        >
          <div class="col-md-3 col-sm-6">
            <button-wrapper
              v-if="!isStudentEnrolled && !isExpired && !notTimeYet"
              class="btn--fill"
              color="darken_blue"
              size="lg"
              @click="enrollVisit"
            >
              報名活動
            </button-wrapper>

            <button-wrapper
              v-else
              class="btn--fill"
              size="lg"
              disabled
            >
              {{ isStudentEnrolled ? '已報名活動' : notTimeYet ? '尚未開放報名' : '報名已截止' }}
            </button-wrapper>
          </div>
        </div>
      </div>
      <student-enroll-event-modal
        v-if="isOpenEnrollModal"
        :modal-title="`報名${currentVisitsDetailsGetter.visit_name}`"
        :is-modal-open="isOpenEnrollModal"
        :does-need-travel-accident-insurance="currentVisitsDetailsGetter.visit_insurance_info"
        @modal:close="closeEnrollModal"
        @submit="submitEnrollment"
      />
      <redirect-login-page-modal
        v-if="isOpenRedirectModal"
        auth-type="student"
        :is-modal-open="isOpenRedirectModal"
        @modal:close="closeRedirectModal"
      />
      </div>
    </template>
  </page-article>
</template>
<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import pageArticle from '~components/pages/Article'
import ButtonWrapper from '~components/common/buttons'
import StudentEnrollEventModal from '~components/common/modal/StudentEnrollEvent'
import RedirectLoginPageModal from '~components/common/modal/RedirectLoginPage'
export default {
  name: 'EnterpriseVisitDetailsContent',
  components: {
    pageArticle,
    ButtonWrapper,
    StudentEnrollEventModal,
    RedirectLoginPageModal
  },
  data () {
    return {
      isOpenEnrollModal: false,
      isOpenRedirectModal: false
    }
  },
  computed: {
    ...mapGetters('pages/enterprise-visits', [
      'currentVisitsDetailsGetter'
    ]),
    ...mapGetters('pages/students', [
      'isEnrolledCurrentEnterpriseVisitGetter'
    ]),
    ...mapGetters('auth', [
      'isEnterpriseGetter',
      'isStudentGetter'
    ]),
    isExpired () {
      return moment(this.currentVisitsDetailsGetter.visit_end_date).isBefore(moment())
    },
    notTimeYet () {
      if (this.currentVisitsDetailsGetter.visit_start_date) {
        return this.$moment().isBefore(this.$moment(this.currentVisitsDetailsGetter.visit_start_date))
      }
      return true
    },
    isStudentEnrolled () {
      if (this.isStudentGetter) {
        return this.isEnrolledCurrentEnterpriseVisitGetter(Number(this.$route.params.id))
      }
      return false
    }
  },
  async created () {
    try {
		await this.getVisitsDetailsById(this.$route.params.id);
	} catch (err) {
		this.$router.push('/enterprise-visits');
	}
    if (this.isStudentGetter) {
      await this.getEnterpriseVisitEnrolledRecords()
    }
  },
  methods: {
    ...mapActions('pages/enterprise-visits', [
      'getVisitsDetailsById'
    ]),
    ...mapActions('pages/students', [
      'createStudentEnterpriseVisitEnrollment',
      'getEnterpriseVisitEnrolledRecords'
    ]),
    ...mapActions('layouts', [
      'toggleModal'
    ]),
    enrollVisit () {
      if (this.isStudentGetter) {
        this.isOpenEnrollModal = true
      } else {
        this.isOpenRedirectModal = true
      }
      this.toggleModal(true)
    },
    closeEnrollModal () {
      this.isOpenEnrollModal = false
      this.toggleModal(false)
    },
    closeRedirectModal () {
      this.isOpenRedirectModal = false
      this.toggleModal(false)
    },
    async submitEnrollment (enrollment) {
      const request = { visit_id: this.$route.params.id, ...enrollment }
      await this.createStudentEnterpriseVisitEnrollment(request)
      await this.getEnterpriseVisitEnrolledRecords()
      this.$router.push({
        path: '/students',
        query: {
          tab: '活動紀錄',
          sub: '企業參訪'
        }
      })
    },
	check_full() {
		if(this.currentVisitsDetailsGetter.visit_students_count >= this.currentVisitsDetailsGetter.visit_taker)
			return 'color: #f04b2d; margin-right: 8px;';
		return 'color: #00ba09; margin-right: 8px;';
	}
  }
}
</script>